function zipcode_datail_autocomplete() {
    var zipcode = document.getElementById("zipcode").value ;
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.open('GET', "https://thorv2.confiejarvis.com/thor/get/"+zipcode+".json", true);
    xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == 4) {
            if(xmlhttp.status == 200) {
                var obj = JSON.parse(xmlhttp.responseText);                        
                document.getElementById("form_cityState").value = obj.data.City +", "+ obj.data.State; 
                document.getElementById("field_city").value = obj.data.City ; 
                document.getElementById("field_state").value = obj.data.StateCode;                         
                var countryList = obj.countrylist;
            }else{
                document.getElementById("form_cityState").value = "";  
                document.getElementById("field_city").value = ""; 
                document.getElementById("field_state").value = ""; 
            }
        }
    };
    xmlhttp.send(null);
}
console.log(jQuery("#zipcode").length);


jQuery(function ($) { 
    if(jQuery("#DependentsCount").length){
        $("#DependentsCount").change(function() {
            var val = $(this).val();
            for (var i = 1; i <= 8; i++) {
                if (i>val) {
                    $('#Adult'+i).closest('.Adult'+i).slideUp();
                    // console.log('.Adult'+i);
                } else if ($('#Adult'+i).closest('.Adult'+i).is( ':hidden' )) {
                    // console.log('no paso');
                    $('#Adult'+i).closest('.Adult'+i).slideDown();
                    // console.log('.Adult'+i);
                }
            }
        });
    }

    console.log(jQuery("#zipcode").length);
    if(jQuery("#zipcode").length){
        if(jQuery("#zipcode").val().length !== 0){
            zipcode_datail_autocomplete();
        }
    }
});
if(jQuery(".money")){
    $(".money").on({
        "focus": function (event) {
            $(event.target).select();
        },
        "keyup": function (event) {
            $(event.target).val(function (index, value ) {
    
                if (value != '') {
                    return "$" + value.replace(/\D/g, "")
                            // .replace(/([0-9])([0-9]{2})$/, '$1.$2')
                            .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");
                }
                
            });
        }
    });
}
